import { MuiColorInput, MuiColorInputProps } from 'mui-color-input';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

type FormTextFieldProps = Omit<MuiColorInputProps, 'value'> & {
  name: string;
};

const FormColorPicker = ({ name, sx, ...rest }: FormTextFieldProps) => {
  const { field } = useController({ name });
  const {
    formState: { errors },
  } = useFormContext<{ [key: string]: string }>();

  return (
    <MuiColorInput
      sx={{
        div: {
          backgroundColor: (t) => t.palette.background.paper,
        },
        ...sx,
      }}
      {...field}
      {...rest}
      format="hex"
    />
  );
};

export default FormColorPicker;
